<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{
    name: 'mv-program-form',

    props:
    {
        model: Object,
        edit: Boolean,
    },

    computed:
    {
        ...mapGetters({
            artists: 'artistList',
            locations: 'locationList',
            locale: 'generalCurrentLocale',
            categories: 'programcategoriesList',
        }),

        locationOptions()
        {
            const options = []
            for (let i = 0; i < this.locations.length; ++i)
            {
                options.push({
                    label: this.locations[i].name,
                    attachments: this.locations[i].attachments,
                    id: this.locations[i].id
                })
            }
            return options
        },

        locationValue()
        {
            return this.locationOptions.findByModelId(this.model.location_id)
        },

        artistOptions()
        {
            const options = []
            for (let i = 0; i < this.artists.length; ++i)
            {
                options.push({
                    label: this.artists[i].name,
                    attachments: this.artists[i].attachments,
                    id: this.artists[i].id
                })
            }
            return options
        },

        artistValue()
        {
            return this.artistOptions.findByModelId(this.model.artist_id)
        },
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        locationOnChange(val)
        {
            if (val && val.id)
                this.model.location_id = val.id
        },

        artistOnChange(val)
        {
            if (val && val.id)
                this.model.artist_id = val.id
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        cloneProgram()
        {
            axios.post(`${process.env.API_URL}/v1/admin/program-clone/${this.model.id}`).then(() => {
              this.$emit('save')
            })
        }

    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.NAME') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.SLUG') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.slug">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.START') }}
            </label>
            <div class="col-md-6">
                <mv-date-time-picker v-model="model.start"></mv-date-time-picker>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.END') }}
            </label>
            <div class="col-md-6">
                <mv-date-time-picker v-model="model.end"></mv-date-time-picker>
            </div>
        </div>

        <div class="form-group row">
            <label for="is_all_day" class="col-md-4 control-label">
                Egész napos?
            </label>
            <div class="col-md-6">
                <input type="checkbox" name="is_all_day" v-model="model.is_all_day">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.LOCATION') }}
            </label>
            <div class="col-md-6">
                <v-select :value="locationValue" :options="locationOptions" @input="locationOnChange">
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-2 hidden-sm hidden-xs">
                                <div v-if="option.attachments && option.attachments.length">
                                    <img :src="option.attachments[0].thumbnail_url">
                                </div>
                            </div>
                            <div class="col-sm-10 text">
                                <div class="text">
                                    {{ option.label }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.ARTIST') }}
            </label>
            <div class="col-md-6">
                <v-select :options="artists" v-model="model.artists" multiple label="name">
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('WISHLIST.CATEGORIES') }}
            </label>
            <div class="col-md-6">
                <v-select :options="categories" v-model="model.program_categories" multiple label="name">
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_SITE') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" name="on_site" v-model="model.on_site">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_MOBILE') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" name="on_site" v-model="model.on_mobile">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('POST.PINNED') }}
            </label>
            <div class="col-md-8">
                <input type="checkbox" v-model="model.pinned">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row" v-if="false">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.DESCRIPTION') }}
            </label>
            <div class="col-md-6">
                <textarea v-model="model.description" class="form-control" v-if="locale == 'hu'"></textarea>
                <textarea v-model="model.description_en" class="form-control" v-else></textarea>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.LONG_DESCRIPTION') }}
            </label>
            <div class="col-md-6">
                <textarea v-model="model.long_description" class="form-control" v-if="locale == 'hu'"></textarea>
                <textarea v-model="model.long_description_en" class="form-control" v-else></textarea>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.IS_CHANGED') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.is_changed">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PROGRAM.CLONE') }}
            </label>
            <div class="col-md-6">
                <button class="btn btn-primary" type="button" @click.prevent.stop="cloneProgram"> {{ $t('PROGRAM.CLONE') }} </button>
            </div>
        </div>
    </form>
</div>
</template>

<style lang="scss">
.option-row {
    height: 4em;
    font-weight: bold;
    font-size: 120%;

    .text {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/ProgramForm.vue